/** @format */

import React, { Suspense } from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import { GlobalStyle, ModalProvider, theme } from "senf-atomic-design-system";
import { AuthProvider, GlobalStateProvider } from "senf-shared";
import { ThemeProvider } from "styled-components";
import store from "./redux/store";
import "senf-tokens/fonts.css";
import "senf-tokens/tailwind.css";
import "senf-tokens/output/global.css";
import "senf-tokens/output/light.css";
import { captureException, initSentry } from "senf-shared/utils/sentry";

initSentry();

// Reload the page if a dynamic import fails (e.g., due to deployment changes)
// Failed to fetch dynamically imported module while user was on the page
window.addEventListener("vite:preloadError", (event) => {
  console.error("Vite preload error detected, reloading page...", event);
  captureException(event, {
    message: "Vite preload error occurred",
    source: "index.jsx",
    context: "Dynamic import failure",
  });
  window.location.reload();
});

let LandingPage;
if (
  import.meta.env.VITE_APP_MODE === "staging" ||
  import.meta.env.VITE_APP_MODE === "development"
) {
  LandingPage = React.lazy(() => import("./pages/DevLandingPage"));
} else {
  LandingPage = React.lazy(() => import("./pages/LandingPage"));
}

const App = React.lazy(() => import("./App"));
const root = createRoot(document.getElementById("root"));

root.render(
  // <React.StrictMode>
  <Suspense fallback={null}>
    <ThemeProvider theme={theme}>
      <GlobalStyle />

      <GlobalStateProvider>
        <Router>
          <Provider store={store}>
            <AuthProvider>
              <ModalProvider>
                <Routes>
                  <Route path="/" element={<LandingPage />} />
                  <Route path="/info" element={<LandingPage />} />
                  <Route path="*" element={<App />} />
                </Routes>
              </ModalProvider>
            </AuthProvider>
          </Provider>
        </Router>
      </GlobalStateProvider>
    </ThemeProvider>
  </Suspense>,
);
// expose store when run in Cypress
if (window.Cypress) {
  window.store = store;
}
